/*
@file-overview 

- This service was brougth over from AEM wcax-commons repo

- Contains the methods used for handling actions for getting offer-details info to show in
    the right drawer

*/
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';

import { CommonService } from './common.service';


import { AemService } from './aem.service';
import { EnviormentConfig } from '../wcax-env-config';
import { UserInfoService } from './user-info.service'
import { UtilService } from './util.service';

@Injectable()
export class OfferDetailService {
    // DFTA - wcax env config
    private config = EnviormentConfig;

    public currentEnv = '';

    public couponUpdated = new BehaviorSubject({});

    public constructor(  private http: HttpClient,
                        private _commonService: CommonService,
                        private _userInfoService: UserInfoService,
                        private _http: HttpClient,
                        private _utilService : UtilService,
                        private _aemService: AemService
                      ) 
     {
       this.currentEnv = this._commonService.getCurrentEnviorment();
     }

    /**
     * Get data from API Endpoint.
     *
     * @param {any} offerId
     * @param {any} offerts
     * @param {any} offerType
     */


    public getOfferDetailData(offerId: any, offerType: any, configObj: any): Observable<any> {
        const storeId = this._userInfoService.getShopStoreId();

        let apiUrl = this.config[this.currentEnv].offerDetailAPIDetails['offerDetailPath'] + `?offerId=${offerId}&storeId=${storeId}&offerPgm=${offerType}&includeUpc=y`;

        const httpHeaders = {
            "Content-Type": "application/json",
            "X-SWY-APPLICATION-TYPE": "web",
            "X-SWY_API_KEY": "emjou",
            "X-SWY_VERSION": "2.1"
        };

        const wiremockAPIDetails = this.config[this.currentEnv].wiremockAPIDetails;
        if (wiremockAPIDetails?.allowWiremockService) {
            const mode = this._utilService.getParams('mode');
            const wireMockSubscriptionKey = wiremockAPIDetails?.subscriptionKey;
            if (mode === 'playback') {
                apiUrl = wiremockAPIDetails?.playbackBaseUrl + apiUrl;
                httpHeaders['Ocp-Apim-Subscription-Key'] = wireMockSubscriptionKey;
            } else if (mode === 'record') {
                apiUrl = wiremockAPIDetails?.recorderBaseUrl + apiUrl;
                httpHeaders['Ocp-Apim-Subscription-Key'] = wireMockSubscriptionKey;
            }
        }

        if (this._userInfoService.getSWY_SHOP_TOKEN()) {
            httpHeaders['Authorization'] = `Bearer ${this._userInfoService.getSWY_SHOP_TOKEN()}`;
        }

        const httpOptions = {
            headers: new HttpHeaders(httpHeaders)
          };

        if (configObj && configObj.bannerDomain) {
            apiUrl = configObj.bannerDomain + apiUrl;
        }

        return this._http.get(apiUrl, httpOptions).pipe(
            map((data) => {
                // is BXGY offer eligible and offer is NDC coupon
                const isBXGYEligibleOffer = this._commonService.getIsOfferEligibleBXGY(data) && (this._commonService.isEmpty(configObj?.programType) || configObj?.programType === 'abs');
                if(isBXGYEligibleOffer) {
                    this._commonService.bxgyOffer.next({
                        upcList: data['upcList'],
                        eligibleUpcList: data['getEligibleUpcList'],
                        offerDetail: data['offerDetail'],
                        offerProgramType: data['offerProgramType'],
                        offerProtoType: data['offerProtoType'],
                    });
                    // if upcList is empty then set upcList as getEligibleUpcList for BXGY
                    if(!data['upcList']?.length) {
                        this._commonService.upcs.next(data['getEligibleUpcList']);
                    }
                    else {
                        this._commonService.upcs.next(data['upcList']);
                    }
                }
                else {
                    this._commonService.upcs.next(data['upcList']);
                }
                return data;
            }),
            catchError((error) => {
                this._commonService.upcs.next([]);
                this._commonService.bxgyOffer.next({});
                return of({});
            })
        );
    }
    public getOfferDisclaimerTemplate(offerDisclaimerXpath: string, configObj: any): Observable<any>{
        if (configObj && configObj.bannerDomain) {
            offerDisclaimerXpath = configObj.bannerDomain + offerDisclaimerXpath;
        }
        const offerDetailDisclaimerTemplate = this._http.get(offerDisclaimerXpath, { 'responseType': 'text' });
        return offerDetailDisclaimerTemplate;
    }

    public getCMSOfferData(offerId: any, configObj: any) {
        const storeId = this._userInfoService.getShopStoreId();

        let apiUrl = `${this.config[this.currentEnv].offerDetailAPIDetails['upcsByOfferIds']}?storeId=${storeId}&offerId=${offerId}`;

        if (configObj && configObj.bannerDomain) {
            apiUrl = configObj.bannerDomain + apiUrl;
        }

        const httpHeaders = {
            "Content-Type": "application/json;charset=utf-8",
            "X-SWY_API_KEY": "emjou",
            "X-SWY_APP_ID": "emjou",
            "X-SWY-BANNER": "safeway",
            "X-SWY_VERSION": "1.0"
        };

        if (this._userInfoService.getSWY_SHOP_TOKEN()) {
            httpHeaders['Authorization'] = `Bearer ${this._userInfoService.getSWY_SHOP_TOKEN()}`;
        }

        const httpOptions = {
            headers: new HttpHeaders(httpHeaders)
        };

        return this._http.get(apiUrl, httpOptions).pipe(
            map((data) => {
                this._commonService.upcs.next(this.transformData(data));
                return data;
            }),
            catchError((error) => {
                this._commonService.upcs.next([]);
                return of({});
            })
        );
    }

    public getOfferDetailsDataPzn(offerId, storeId, includeUpc, source) {
        let host = this.config[this.currentEnv].baseURL;
        host = host.replace('{banner}', this._userInfoService.getBanner());
        const apiUrl = `${host}${this.config[this.currentEnv].offerDetailAPIDetails['offerDetailsPzn']}?storeId=${storeId}&offerId=${offerId}&includeUpc=y&source=${source}`;
        // let apiUrl = `https://www-qa1.safeway.com/abs/qapub/dce/offergallery/J4UProgram1/services/gallery/offer/detail?storeId=${storeId}&offerId=${offerId}&includeUpc=${includeUpc ? 'y' : 'n'}&source=${source}`;
        // let apiUrl = 'https://www-qa1.safeway.com/abs/qapub/dce/offergallery/J4UProgram1/services/gallery/offer/detail?storeId=2856&offerId=2485000973242024010320241231&includeUpc=y&source=cms';
        const httpHeaders = {
            "Content-Type": "application/json;charset=utf-8",
            "X-SWY_API_KEY": "emju",
            "X-SWY_VERSION": "3.0",
            "Ocp-Apim-Subscription-Key": "xyz"
        };
        if (this._userInfoService.getSWY_SHOP_TOKEN()) {
            httpHeaders['Authorization'] = `Bearer ${this._userInfoService.getSWY_SHOP_TOKEN()}`;
        }
        const httpOptions = {
            headers: new HttpHeaders(httpHeaders)
        };
        return this._http.get(apiUrl, httpOptions).pipe(
            map((data) => {
                if (data && data['upcList']) {
                    this._commonService.upcs.next(data['upcList']);
                } else {
                    this._commonService.upcs.next([]);
                }
                return data;
            }),
            catchError((error) => {
                this._commonService.upcs.next([]);
                return of({});
            })
        );
    }

    private transformData(data) {
        return data['offerUPCList'].map( (a) => a.upcList).join().split(',');
    }

    public addToList(payloadData: any) {
        let host = this.config[this.currentEnv].baseURL;
        host = host.replace('{banner}', this._userInfoService.getBanner());
        const storeId = this._userInfoService.getShopStoreId();
        const apiUrl = host + this.config[this.currentEnv].j4uAPIDetails.clipPath + "?storeId=" + storeId;
        const httpHeaders = {
            "Content-Type": "application/json;charset=utf-8",
            "X-SWY_API_KEY": "emjou",
            "X-SWY_VERSION": "2.0",
        };
        if (this._userInfoService.getSWY_SHOP_TOKEN()) {
            httpHeaders['SWY_sso_token'] = `${this._userInfoService.getSWY_SHOP_TOKEN()}`;
            httpHeaders['Swyconsumerdirectorypro'] = `${this._userInfoService.getSWY_SHOP_TOKEN()}`;
        }
        const httpOptions = {
            headers: new HttpHeaders(httpHeaders)
        };
        return this._http.post(apiUrl, payloadData, httpOptions).pipe(
            map((data) => data),
        );
    }

    public removeFromList(payloadData: any) {
        let host = this.config[this.currentEnv].baseURL;
        host = host.replace('{banner}', this._userInfoService.getBanner());
        const storeId = this._userInfoService.getShopStoreId();
        const apiUrl = host + this.config[this.currentEnv].j4uAPIDetails.unclipPath;
        const httpHeaders = {
            "Content-Type": "application/json;charset=utf-8",
            "X-SWY_API_KEY": "emjou",
            "X-SWY_VERSION": "1.2",
            "X-SWY_BANNER": "safeway"
        };
        if (this._userInfoService.getSWY_SHOP_TOKEN()) {
            httpHeaders['Authorization'] = `Bearer ${this._userInfoService.getSWY_SHOP_TOKEN()}`;
        }
        const httpOptions = {
            headers: new HttpHeaders(httpHeaders)
        };
        return this._http.post(apiUrl, payloadData, httpOptions).pipe(
            map((data) => data),
        );
    }
}
